export default __webpack_public_path__ + "static/media/404.bf1c6bf1.jpg";